export default "__VITE_ASSET__B38$9WIq__"